export default {
    OPEN_SIGNIN_MODAL(state) {
        state.is_signin_modal_open = true;
    },

    CLOSE_SIGNIN_MODAL(state) {
        state.is_signin_modal_open = false;
    },
};
